import React, { useState } from 'react'
import { Box, Button, Copy, Flex, Icon, Image, styles, themeColor } from '@elparking/components'
import { TRADENAME } from 'commons/js/constants'
import { FormattedMessage } from 'react-intl'
import LoginForm from '../LoginForm'
import SectionContainer from './SectionContainer'
import ClickToCallModal from '../Modals/ClickToCallModal'
import styled from 'styled-components'
import { position, boxShadow, top, right } from 'styled-system'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'
import useOnCloseModalAnalyticEvent from 'commons/js/hooks/useOnCloseModalAnalyticEvent'

const LOGIN_PAGE_MODAL = 'login-otp'
const LOGIN_RESET_PASSWORD = 'reset-password'

const LoginContainer = styled.div`
    ${styles.borderColor}
    ${styles.borderRadius}
    ${styles.minWidth}
    ${styles.maxWidth}
    ${styles.overflow}
    ${styles.space}
    ${position}
    ${top}
    ${right}
    ${boxShadow}
    transition: 1s height;
    z-index: 10;
    border-color: ${themeColor('gray30')};
    border-style: solid;
    &:before {
        pointer-events: none;
        z-index: -2;
        content: ' ';
        position: fixed;
        ${styles.backgroundColor}
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }
`

const RegisterForm = () => {
    const [showModal, setShowModal] = useState(false)
    const [formKey, setFormKey] = useState('initialForm')
    const [loginPage, setLoginPage] = useState(null)
    const loginDesktopPosition = loginPage === LOGIN_PAGE_MODAL || loginPage === LOGIN_RESET_PASSWORD
    const onShowClickToCallModal = () => {
        setShowModal(!showModal)
        trackTealiumEvent(RentalCarEvents.eventNoAccountButton)
        trackTealiumEvent(RentalCarEvents.showNoAccountC2CView)
    }
    useOnCloseModalAnalyticEvent(showModal, RentalCarEvents.showRegisterView)
    return <Box p={['0 1em', '0 1em', '0']}>
        <ClickToCallModal
          isShown={showModal}
          onClose={() => setShowModal(false)}
          onSuccessPhoneNumberCallSent={() => {
                trackTealiumEvent(RentalCarEvents.showNoAccountC2CView)
                trackTealiumEvent(RentalCarEvents.noAccountC2CSentView)
                trackTealiumEvent(RentalCarEvents.eventNoAccountC2CSent)
            }}
          step='P4'
        />
        <Copy as='h1' fontSize='xLarge' fontColor='accent_dark' padding='0 0 1em 0'>
            <FormattedMessage defaultMessage='¡Ya casi está! Identifícate y finaliza tu reserva' />
        </Copy>
        <Box mb='1em'>
            <SectionContainer width='100%' padding='1em' minHeight={loginDesktopPosition ? '200px' : 'auto'}>
                <LoginContainer
                  boxShadow={['none', 'none', (loginDesktopPosition ? '0px 2px 4px 0px rgba(0,0,0,0.16);' : 'none')]}
                  borderWidth={['0', '0', (loginDesktopPosition ? '1px' : '0')]}
                  borderRadius={['0', '0', (loginDesktopPosition ? '4px 4px 40px 4px' : '0')]}
                  overflow={['auto', 'auto', (loginDesktopPosition ? 'none' : 'auto')]}
                  top={['0', '0', (loginDesktopPosition ? '10%' : '0')]}
                  right={['0', '0', (loginDesktopPosition ? 'calc(50% - 300px)' : '0')]}
                  minWidth={['100%', '100%', (loginDesktopPosition ? '660px' : '100%')]}
                  maxWidth='100%'
                  backgroundColor={['transparent', 'transparent', (loginDesktopPosition ? 'rgba(0,0,0,0.16)' : 'transparent')]}
                  position={['relative', 'relative', (loginDesktopPosition ? 'absolute' : 'relative')]}>
                    <Box width='100%' background='white' padding={['0', '0', (loginDesktopPosition ? '20px' : '0')]}>
                        <Box textAlign='right' display={['none', 'none', (loginDesktopPosition ? 'block' : 'none')]}>
                            <Button.unstyled onClick={() => setFormKey(Date.now())}>
                                <Icon type='x' fontSize='large' fontColor='gray' />
                            </Button.unstyled>
                        </Box>
                        {loginDesktopPosition
                            ? <Box w='100%'>
                                <Copy textAlign='center'>
                                    <Image src='/images/rental-car/login-otp.svg' width='140px' height='140px' alignSelf='center' alt='OTP' />
                                </Copy>
                                <Box width='100%' display={['block', 'block', (loginDesktopPosition ? 'none' : 'block')]}>
                                    <Copy fontSize='medium' fontColor='accent_dark' padding='0 0 1em 0' textAlign='center'>
                                        <FormattedMessage defaultMessage='Necesitamos verificar tu identidad' />
                                    </Copy>
                                </Box>
                            </Box>
                            : <Copy fontSize='medium' fontColor='accent_dark' padding='0 0 1em 0'>
                                <FormattedMessage defaultMessage='Inicia sesión en {tradename}' values={{
                                    tradename: TRADENAME,
                                }} />
                            </Copy>}
                        <LoginForm key={formKey} onNavigation={e => setLoginPage(e.page)} />
                    </Box>
                </LoginContainer>
            </SectionContainer>
        </Box>
        <SectionContainer width='100%' padding={['2em 1em', '1em']} background='url(/images/rental-car/register-background.webp)'>
            <Flex alignItems='center' flexDirection={['column', 'row']}>
                <Box mt={['1.5em', '0']} w={['100%', 'calc(100% - 180px)']}>
                    <Copy fontSize='medium' textAlign={['center', 'left']} fontColor='accent_dark' padding={['0', '0 2em 0 0']}>
                        <FormattedMessage defaultMessage='Si aún no tienes cuenta en {tradename}, te llamamos gratis' values={{
                            tradename: TRADENAME,
                        }} />
                    </Copy>
                </Box>
                <Box mt={['1.5em', '0']} w={['100%', '180px']}>
                    <Button.bordered height='auto' width='100%' onClick={() => onShowClickToCallModal()} backgroundColor='transparent'>
                        <FormattedMessage defaultMessage='No tengo cuenta' />
                    </Button.bordered>
                </Box>
            </Flex>
        </SectionContainer>
    </Box>
}

export default RegisterForm
